import { BasketItem, Currency } from "../../containers/NewOrderContainer/types";

export default (
  formValue: any,
  currencies: Currency[],
  summary: any
): BasketItem => {
  const currencyId: number = parseInt(
    formValue && formValue.currency ? formValue.currency : null
  );
  const currency = currencies.find((c: Currency) => c.id === currencyId);
  return {
    branchId: formValue && formValue.branchId,
    comments: formValue && formValue.comments,
    referenceForInvoice: formValue && formValue.referenceForInvoice,
    currencyId: currencyId,
    currency:
      (currency ? currency.region : "") +
      " - " +
      (currency ? currency.name : ""),
    currencyAmount: formValue && formValue.currencyAmount,
    exchangeRate: summary && summary.rate,
    travellerBeneficiary: formValue && formValue.travellerBeneficiary,
    required: formValue && formValue.selectedDate,
    settlement: summary && summary.baseCurrencyCode,
    denominations: formValue && formValue.denominations,
    settlementSource: formValue && formValue.settlementSource
  };
};
